import moment from 'moment';
import 'moment/dist/locale/ru';
import 'moment/dist/locale/de';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/he';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/tr';

import localeBN from '@/i18n/messages/bn/locale_bn';
moment.defineLocale('bn', localeBN);

window.moment = moment;

export default moment;

export function MomentSetup(app) { 
  app.config.globalProperties.$moment = moment;
}